import { createAction, props } from '@ngrx/store';
import { Project, ProjectCampaignResponse, ProjectCreate } from '@core/models/projects.model';

// Load projects
export const loadProjects = createAction('[Project] Load Projects');

export const loadProjectsSuccess = createAction('[Project API] Load Projects Success', props<{ projects: Project[] }>());

export const loadProjectsFailure = createAction('[Project API] Load Projects Failure', props<{ error: string }>());

// Set current project
export const setCurrentProject = createAction('[Project] Set Current Project', props<{ project: Project | null }>());

// Create project
export const createProject = createAction(
    '[Project] Create Project',
    props<{
        projectData: ProjectCreate;
    }>(),
);

export const createProjectSuccess = createAction('[Project API] Create Project Success', props<{ projectId: number }>());

export const createProjectFailure = createAction('[Project API] Create Project Failure', props<{ error: string }>());

// Update project
export const updateProject = createAction('[Project] Update Project', props<{ projectId: number; projectData: ProjectCreate }>());

export const updateProjectSuccess = createAction('[Project API] Update Project Success', props<{ projectId: number; message: string }>());

export const updateProjectFailure = createAction('[Project API] Update Project Failure', props<{ error: string }>());

// Load project campaigns
export const loadProjectCampaigns = createAction('[Project] Load Project Campaigns', props<{ campaignIds: string[] }>());

export const loadProjectCampaignsSuccess = createAction(
    '[Project API] Load Project Campaigns Success',
    props<{ campaigns: ProjectCampaignResponse }>(),
);

export const loadProjectCampaignsFailure = createAction('[Project API] Load Project Campaigns Failure', props<{ error: string }>());

// Delete project
export const deleteProject = createAction('[Project] Delete Project', props<{ projectId: number }>());

export const deleteProjectSuccess = createAction('[Project API] Delete Project Success', props<{ projectId: number }>());

export const deleteProjectFailure = createAction('[Project API] Delete Project Failure', props<{ error: string }>());

// Clear projects data
export const clearProjects = createAction('[Project] Clear Projects');

export const clearSelectedProject = createAction('[Project] Clear selected Projects');

export const clearProjectCampaigns = createAction('[Project] Clear Project Campaigns');
